import { useTranslation } from 'react-i18next'
import { Outlet } from 'react-router-dom'
import { PageHeader } from '../../../../components/page-header'
import { usePageTitle } from '../../../../hooks/title'

export const SettingsProductRecommendations = () => {
  const { t } = useTranslation(['shared', 'apps'])
  usePageTitle(t('shared:menu.product_recommendations'))

  return (
    <>
      <PageHeader title={t('shared:menu.product_recommendations')} isSticky />
      <Outlet />
    </>
  )
}
